import { coreApiGatewayKeysRemoveSyncSlice } from '../remove';
import { deleteApiGatewayKeyById } from '@api/data-security';

import { createDeleteAsyncSlice, SagaYieldType } from '@sonar-software/xuder';

export const deleteCoreApiGatewayKeysByIdSlice = createDeleteAsyncSlice({
	httpSagaOptions: {
		successCombinationActionCreators: [
			(request) => coreApiGatewayKeysRemoveSyncSlice.syncActionCreator(request)
		]
	},
	name: 'CoreApiGatewayKeysById',
	receive: false,
	request: true,
	requestHandler: deleteApiGatewayKeyById,
	yieldType: SagaYieldType.Latest
});
